var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _c(
        "app-relatorio-base",
        {
          attrs: {
            titulo: "DAEs por período",
            withTabs: false,
            filtro: _vm.filtroDaePeriodo
          },
          on: { gerarGraficos: _vm.findDaesPeriodo }
        },
        [
          _c("dae-totais", {
            attrs: {
              slot: "grafico",
              totalDaeEmitidos: _vm.daesPeriodo.totalDaeSituacao
            },
            slot: "grafico"
          }),
          _c(
            "el-row",
            {
              staticClass: "rowGrafico",
              attrs: { slot: "grafico" },
              slot: "grafico"
            },
            [
              _vm.daesPeriodo
                ? _c("grafico-daes-periodo", {
                    attrs: {
                      filtro: _vm.filtroDaePeriodo,
                      isMeses:
                        _vm.datediff(
                          _vm.filtroDaePeriodo.dateRange[0],
                          _vm.filtroDaePeriodo.dateRange[1]
                        ) > 31,
                      daesPeriodo: _vm.daesPeriodo
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d0e0308", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d0e0308","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/relatoriosDae/DaesPeriodo.vue
// module id = null
// module chunks = 